import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const ThankYou = () => {
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-pink-50 to-amber-100 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full">
        {/* Success Animation */}
        <div className="text-center mb-8">
          <div className="inline-block relative">
            <CheckCircle className="text-green-500 w-24 h-24 animate-bounce" />
            {/* Sprinkles around success icon */}
            {[...Array(12)].map((_, i) => (
              <span
                key={i}
                className="absolute w-2 h-2 rounded-full animate-pulse"
                style={{
                  backgroundColor: ['#ec4899', '#14b8a6', '#fbbf24'][i % 3],
                  top: `${20 + Math.random() * 60}%`,
                  left: `${20 + Math.random() * 60}%`,
                  animationDelay: `${i * 0.1}s`
                }}
              />
            ))}
          </div>
        </div>

        {/* Thank You Message */}
        <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Thank You! 🎉
          </h1>
          <h2 className="text-2xl md:text-3xl font-semibold text-amber-600 mb-6">
            Your Order Request Has Been Sent!
          </h2>
          
          <div className="bg-gradient-to-r from-amber-50 to-pink-50 rounded-2xl p-6 mb-8">
            <p className="text-lg text-gray-700 leading-relaxed">
              We've received your request and are excited to help make your event special!
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mt-4">
              <strong>What's next?</strong> We'll review your order details and get back to you within <span className="text-amber-600 font-bold">24 hours</span> with a custom quote.
            </p>
          </div>

          <div className="border-t border-gray-200 pt-6 mb-8">
            <p className="text-gray-600 mb-2">
              <strong>Your Email Has Been:</strong>
            </p>
            <p className="text-amber-600 font-semibold">Recieved</p>
          </div>

          {/* Sprinkle decoration */}
          <div className="flex justify-center space-x-2 mb-8">
            {[...Array(10)].map((_, i) => (
              <span
                key={i}
                className="inline-block w-2 h-2 rounded-full"
                style={{
                  backgroundColor: ['#ec4899', '#14b8a6', '#fbbf24'][i % 3]
                }}
              />
            ))}
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => navigate('/')}
              className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white px-8 py-6 text-lg rounded-full transition-all duration-300 hover:scale-105 hover:shadow-lg"
            >
              <ArrowLeft className="mr-2" size={20} />
              Back to Home
            </Button>
            <Button
              onClick={() => scrollToSection('flavors')}
              variant="outline"
              className="border-2 border-amber-500 text-amber-600 hover:bg-amber-50 px-8 py-6 text-lg rounded-full transition-all duration-300 hover:scale-105"
            >
              View Our Flavors
            </Button>
          </div>
        </div>

        {/* Footer Note */}
        <div className="text-center mt-8">
          <p className="text-gray-600 italic">
            "A Sweeter Way to Give"
          </p>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;